<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_stock_levels'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
          
                <div id="tickets-table_filter" class="dataTables_filter d-flex justify-content-end align-items-center">
                <label class="d-inline-flex align-items-center me-2">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                                     
              </div>


                <div id="tickets-table_filter" class="ms-2">
              
            </div>
              </div>
              </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
                class="text-center"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  <div>{{ data.item.name }}</div>
                  <small class="text-success fw-bold">{{ data.item.category.name }}</small>
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit.unit_name }}
                </template>
              
                <template #cell(quantities)="data">
                  <div class="row text-center mb-2">
                    <div class="col bg-dark text-light rounded mx-1">Batch</div>
                    <div class="col bg-dark text-light rounded mx-1">
                     System Quantity
                    </div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Actual Quantity
                    </div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Actions
                    </div>
                  </div>
                  <div
                    class="row text-center mb-1"
                    v-for="(quantity, index) in data.item.quantities"
                    :key="index"
                  >
                    <div class="col align-items-center">
                      {{ quantity.batch }}
                    </div>
                    <div class="col">{{ quantity.quantity }}</div>
                  
                    <div class="col">
                      <b-form-input
                        v-model="quantity.actualQuantity"
                        type="number"
                        class="form-control form-control-sm"
                        :placeholder="'Enter quantity for ' + quantity.batch"
                      ></b-form-input>
                    </div>
                    <div class="col">
                   
                      <button
                        @click="confirmUpdate(data.item.id, data.item.name, quantity)"
                        class="btn btn-sm btn-success"
                        :class="{ disabled: loader }"
                      >
                        <b-spinner
                          v-if="loader"
                          small
                          class="mr-1"
                          label="Saving"
                        />
                        <span v-else>Save</span>
                      </button>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <b-modal
              id="update-item"
              centered
              title="Update Quantity"
              title-class="font-18"
              hide-footer
            >
              <form
                @submit.prevent="saveActualQuantity(product_id, name, quantity)"
              >
                <input v-model="product_id" type="hidden" />
                Are you sure you want to update the quantity for
                <b>{{ name }}</b>?
                <div class="form-group d-flex justify-content-end mt-3">
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="$bvModal.hide('update-item')"
                  >
                    Close
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="ms-2"
                  >
                    <i class="fas fa-check-circle"></i> YES
                  </b-button>
                </div>
              </form>
            </b-modal>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to View Stock Levels</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { productMethods, productComputed } from "@/state/helpers";
import axios from "axios";

export default {
  page: {
    title: "Batch Levels",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Stock Levels",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "System Stock Levels", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true, tdClass: "align-middle" },
        { key: "id", label: "ID", visible: false },
        {
          key: "name",
          label: "Product",
          visible: true,
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "category",
          label: "Category",
          visible: false,
          tdClass: "align-middle",
        },
        {
          key: "quantities",
          label: "Batches",
          visible: true,
          tdClass: "align-middle",
          sortable: true,
        },
 
      ],
      id: "",
      name: "",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      date_today: "",
      loader: false,
      actualQuantity:'',
      product_id:null,
    };
  },
  computed: {
    ...productComputed,
    List() {
      return this.products.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.products.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.products.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.initializePage();
    this.fetchProducts();
    this.getDatePart();
    this.TotalRows = this.products.length;
    this.isBusy = false;
  },
  methods: {


    async initializePage() {
    this.isBusy = true;  // Set loading state (if needed)
    await this.fetchProducts();  // Wait for fetchProducts() to complete
    this.getDatePart();  // Now it's safe to proceed
    this.TotalRows = this.products.length;
    this.isBusy = false;  // End loading state
  },
    getDatePart() {
      let today = new Date();
      this.date_today = today;
    },
    confirmUpdate(product_id, name, quantity) {
      this.product_id = product_id;
      this.name = name;
      this.quantity = quantity;
      this.$bvModal.show('update-item');
    },
   
    
 
    async saveActualQuantity(product_id, name, quantity) {
      this.loader = true;
      const obj = {
        product: product_id,
        name: name,
        quantity_id: quantity.id,
        actual_quantity: quantity.actualQuantity,
      };

      const url = 'update_actual_quantity';
      await axios.post(url, obj);
      await this.fetchProducts();

      this.loader = false;
      this.$bvModal.hide('update-item');
    },



    ...productMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
